import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
});

const TOKEN_KEY = 'zita_token';

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common.Authorization;
  }
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

// Initialize on load
const savedToken = getAuthToken();
if (savedToken) {
  api.defaults.headers.common.Authorization = `Bearer ${savedToken}`;
}

// Endpoints where a 401 is a legitimate application-level rejection (wrong
// current password, wrong login credentials, wrong admin PIN, …) and must
// NOT wipe the session or bounce the user to /login. Real session-loss 401s
// come from every OTHER endpoint (e.g. GET /auth/me, protected data calls).
const APP_401_ENDPOINTS = [
  '/auth/login',
  '/admin/login',
  '/admin/step-up',
  '/auth/change-password',
];

const is_app_level_401 = (config) => {
  const url = (config && config.url) || '';
  return APP_401_ENDPOINTS.some((path) => url.includes(path));
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !is_app_level_401(err.config)) {
      setAuthToken(null);
      // Force a soft reload to /login unless we're already on an auth screen.
      const p = window.location.pathname;
      const onAuthScreen = p.startsWith('/login')
        || p.startsWith('/register')
        || p.startsWith('/forgot')
        || p.startsWith('/reset')
        || p.startsWith('/verify')
        || p === '/';
      if (!onAuthScreen) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  },
);
